<template>
    <va-create-layout>
        <product-type-form :title="title" :item="item"></product-type-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"]
};
</script>
